<template>
    <div>

        <div class="mt-5 mb-5 valid-button" v-if="!isValid && !readOnly">

            <div class="title-valid-button">
                <v-icon color="warning">warning</v-icon>
                Informations manquantes
            </div>

            <!-- Alertes -->
            <div class="mt-3">
                <div v-if="account.cadh_configurations.length === 0">
                    Aucun formulaire d'adhésion n'est configuré sur votre compte.
                </div>

                <div v-if="account.configurations.organism === null">
                    Le nom de votre structure est requis.
                </div>

                <div v-if="account.configurations.cgu === null">
                    Vos CGU ne sont pas renseignées.
                </div>

                <div v-if="account.configurations.logo === null">
                    Votre logo n'est pas renseigné.
                </div>

                <div v-if="!account.configurations.oneSender">
                    Vous devez vérifier au moins une adresse e-mail émetteur auprès de notre service d'envoi d'e-mail.
                </div>

                <div v-if="hasEntityAndProvider || isEmptySelection">
                    Vous devez sélectionner le <span class="span-link" @click="changeStepToSelection">type
                        d'offres</span> de votre campagne.
                </div>

                <div v-if="sender === null">
                    Vous devez renseigner la <span class="span-link" @click="changeStepToEmail">boîte d'envoi</span>.
                </div>

                <div v-if="subject === ''">
                    Vous devez renseigner l'
                    <span class="span-link" @click="changeStepToEmail">objet</span>
                    de l'e-mail envoyé aux prestataires.
                </div>

                <div v-if="firstPartEmail === ''">
                    Vous devez renseigner la
                    <span class="span-link" @click="changeStepToEmail">1ère partie</span>
                    de l'e-mail envoyé aux prestataires.
                </div>

                <div v-if="lastPartEmail === ''">
                    Vous devez renseigner la
                    <span class="span-link" @click="changeStepToEmail">2nd partie</span>
                    de l'e-mail envoyé aux prestataires.
                </div>

                <div v-if="cadhConfigId === null">
                    Vous devez choisir le
                    <span class="span-link" @click="changeStepToFormulaire">bulletin d'adhésion</span>
                    associé à la campagne.
                </div>
            </div>
        </div>

        <!-- Options -->
        <div class="mt-5 mb-5 valid-button">
            <div class="title-valid-button">
                <v-icon color="primary">list</v-icon>
                Les options de la campagne
            </div>
            <div class="mt-3 d-flex flex-row">
                <div class="col w-50">
                    <div v-if="!isRevival">
                        Envoi d'e-mails :
                        <span v-if="noEmail" class="text-danger">Désactivé</span>
                        <span v-else class="text-success">Activé</span>
                    </div>
                    <div v-else>
                        Envoi d'e-mails :
                        <span class="text-success">Activé</span>
                    </div>

                    <div>
                        Un seul e-mail par destinataire :
                        <span v-if="singleEmail" class="text-success">Activé</span>
                        <span v-else class="text-danger">Désactivé</span>
                    </div>
                </div>

                <div class="col w-50 container"
                     v-if="criterias !== undefined && criterias.length && selectedCriterias.length">
                    Critères internes sélectionnés :
                    <div class="row">
                        <div v-for="criteria in criterias.filter( item => selectedCriterias.includes(item.id))"
                             :key="criteria.id">
                            <v-chip class="p-2 m-2 bg-primary text-white">
                                {{ criteria.libelle }}
                            </v-chip>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <!-- Date & Heure -->
        <div class="valid-button mt-3" :class="{ 'disabled-content': !isValid }" v-if="!readOnly">
            <div class="title-valid-button">
                Planification du 1er envoi
            </div>
            <div class="mt-3">
                Nombre de fiches présentes dans le groupe d'envoi :
                <span class="text-success">{{emailsValid.length}}</span>
            </div>
            <div class="mt-3 row">
                <div class="col-6">
                    <v-dialog v-model="openStart" persistent max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field label="Date de 1er envoi" :value="sentAt" readonly outlined v-on="on">
                            </v-text-field>
                        </template>
                        <v-date-picker @change="saveSent" locale="fr-FR" @input="setSentAt" color="primary"
                                       :first-day-of-week="1">
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="openStart = false">Annuler</v-btn>
                            <v-btn text color="primary" @click="openStart = false">Valider</v-btn>
                        </v-date-picker>
                    </v-dialog>
                </div>

                <div class="col-6">
                    <v-menu v-model="menuHour" :close-on-content-click="false" :return-value.sync="time" ref="menu"
                            max-width="290px" min-width="290px">
                        <template v-slot:activator="{ on }">
                            <v-text-field :value="time" label="Heure d'envoi" prepend-icon="access_time" outlined
                                          readonly v-on="on">
                            </v-text-field>
                        </template>
                        <v-time-picker color="primary" v-if="menuHour" v-model="time" full-width
                                       @click:minute="$refs.menu.save(time)" format="24hr">
                        </v-time-picker>
                    </v-menu>
                </div>
            </div>

            <div class="d-flex justify-content-end gap-20">
                <v-btn class="default-button" :disabled="!isValid || sentAt === null" v-if="!updateMode" @click="save">
                    Finaliser
                </v-btn>

                <v-btn class="default-button" :disabled="!isValid || sentAt === null" v-else @click="updateRevival">
                    Mettre à jour
                </v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"

export default {
    name: "Finalize",
    props: ["providers", "cadhName", "isRevival", "cadhId", "updateMode", "batchId", "criterias", "cadh", "readOnly"],
    data() {
        return {
            openStart: false,
            today: null,
            time: "08:00",
            menuHour: false,
        }
    },
    methods: {
        ...mapMutations("createCadh", ["setSentAt", "setCurrentStep", "setSelectedCriterias", "setNoEmail", "setSingleEmail"]),
        save() {
            let dateTime = this.sentAt

            if (this.time !== null) {
                dateTime += " " + this.time
            }

            let providerIds = []
            let entityIds = []

            if (this.selectedApidaeSelection === null) {
                providerIds = this.emailsValid.map(provider => provider.id)
            } else if (this.cadhType !== null && (this.cadhType.value === "ENT" || this.cadhType === "ENT")) {
                entityIds = this.emailsValid.map(entity => entity.external_id)
            } else {
                providerIds = []
            }

            let payload = {
                name: this.cadhName,
                providerIds: providerIds,
                entityIds: entityIds,
                senderId: this.sender.id,
                subject: this.subject,
                firstPartEmail: this.firstPartEmail,
                lastPartEmail: this.lastPartEmail,
                signature: this.signature,
                sentAt: dateTime,
                criterias: this.selectedCriterias,
                apidaeSelection: this.selectedApidaeSelection,
                noEmail: this.noEmail,
                singleEmail: this.singleEmail,
                configId: this.cadhConfigId,
                type: this.cadhType === null ? 'OBJ' :
                  typeof this.cadhType === 'object' ? this.cadhType.value : this.cadhType,
            }

            if (this.isRevival) {
                this.saveRevival(payload)
            } else {
                this.$global.loading = true

                this.$http.post("auth/campaigns/cadh/create", payload).then(res => {
                    this.$global.loading = false

                    this.$router.push("/campaigns")
                })
            }
        },
        saveRevival(payload) {
            delete payload.name
            delete payload.providerIds
            delete payload.signature
            delete payload.senderId
            delete payload.configId

            payload.cadhId = this.cadhId

            this.$global.loading = true

            this.$http.post("auth/campaigns/cadh/revival/create", payload).then(res => {
                this.$global.loading = false

                this.$router.push("/campaigns")
            })
        },
        updateRevival() {
            let dateTime = this.$moment(this.sentAt, "DD-MM-YYYY").format("YYYY-MM-DD")

            if (this.time !== null) {
                dateTime += " " + this.time
            }

            let payload = {
                subject: this.subject,
                firstPartEmail: this.firstPartEmail,
                lastPartEmail: this.lastPartEmail,
                sentAt: dateTime,
                batchId: this.batchId,
                criterias: this.selectedCriterias,
                noEmail: this.noEmail,
                singleEmail: this.singleEmail,
                configId: this.cadhConfigId,
            }

            this.$global.loading = true

            this.$http.post("auth/campaigns/cadh/revival/update", payload).then(res => {
                this.$global.loading = false

                this.$router.push("/campaigns")
            })
        },
        changeStepToEmail() {
            this.setCurrentStep(parseInt(this.currentStep) - 2)
        },
        changeStepToFormulaire() {
            this.setCurrentStep(parseInt(this.currentStep) - 3)
        },
        changeStepToSelection() {
            if (this.currentStep === "6") {
                this.setCurrentStep(parseInt(this.currentStep) - 5)
            } else {
                this.setCurrentStep(parseInt(this.currentStep) - 3)
            }
        },
        saveSent(value) {
            this.openStart = false

            let date = this.$moment(value).format("DD-MM-YYYY")

            this.setSentAt(date)
        },
    },
    computed: {
        ...mapState("createCadh", [
            "sender",
            "subject",
            "firstPartEmail",
            "lastPartEmail",
            "signature",
            "sentAt",
            "selectedFields",
            "emailsValid",
            "currentStep",
            "selectedCriterias",
            "selectedApidaeSelection",
            "noEmail",
            "singleEmail",
            "cadhType",
            "hasEntityAndProvider",
            "cadhConfigId",
            'emailsValid',
            'isEmptySelection',
        ]),
        ...mapState("account", ["account"]),
        isValid() {
            return this.account.cadh_configurations.length !== 0 &&
              this.account.configurations.logo !== null &&
              this.account.configurations.cgu !== null &&
              this.account.configurations.organism !== null &&
              this.account.configurations.oneSender &&
              this.subject !== "" &&
              this.firstPartEmail !== "" &&
              this.lastPartEmail !== "" &&
              !this.hasEntityAndProvider &&
              this.cadhConfigId !== null &&
              !this.isEmptySelection
        },
    },
    watch: {
        noEmail() {
        },
        singleEmail() {
        },
        selectedCriterias() {
        },
    },
    created() {
        this.today = this.$moment().format("YYYY-MM-DD")

        if (this.updateMode) {
            let sentAt = this.sentAt
            let date = this.$moment(sentAt).format("DD-MM-YYYY")

            this.setSentAt(date)

            this.time = this.$moment(sentAt).format("HH:mm")
        }
    },
}
</script>
